import React from "react";

import { Decimal, StabilityDeposit, StabilityDepositChange } from "@liquity/lib-base";

import { COIN, GT } from "../../strings";
import { ActionDescription, Amount } from "../ActionDescription";

type StabilityActionDescriptionProps = {
  originalDeposit: StabilityDeposit;
  change: StabilityDepositChange<Decimal>;
};

export const StabilityActionDescription: React.FC<StabilityActionDescriptionProps> = ({
  originalDeposit,
  change
}) => {
  const collateralGain = originalDeposit.collateralGain.nonZero?.prettify(4).concat(" BNB");
  const sableReward = originalDeposit.sableReward.nonZero?.prettify().concat(" ", GT);

  return (
    <ActionDescription>
      {change.depositUSDS ? (
        <>
          You are depositing{" "}
          <Amount>
            {change.depositUSDS.prettify()} {COIN}
          </Amount>{" "}
          in the Stability Pool
        </>
      ) : (
        <>
          You are withdrawing{" "}
          <Amount>
            {change.withdrawUSDS.prettify()} {COIN}
          </Amount>{" "}
          to your wallet
        </>
      )}
      {(collateralGain || sableReward) && (
        <>
          {" "}
          and claiming at least{" "}
          {collateralGain && sableReward ? (
            <>
              <Amount>{collateralGain}</Amount> and <Amount>{sableReward}</Amount>
            </>
          ) : (
            <Amount>{collateralGain ?? sableReward}</Amount>
          )}
        </>
      )}
      .
    </ActionDescription>
  );
};
